import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import config from "@/app/context/config";

interface CustomizerState {
	activeMode: string;
	activeTheme: string;
	activeLayout: string;
	isCardShadow: boolean;
	isLayout: string;
	isCollapse: string;
	isLanguage: string;
	isSidebarHover: boolean;
	isMobileSidebar: boolean;
	isLoading: boolean;
}

const initialState: CustomizerState = {
	activeMode: config.activeMode,
	activeTheme: config.activeTheme,
	activeLayout: config.activeLayout,
	isCardShadow: config.isCardShadow,
	isLayout: config.isLayout,
	isCollapse: config.isCollapse,
	isLanguage: config.isLanguage,
	isSidebarHover: false,
	isMobileSidebar: false,
	isLoading: true,
};

const customizerSlice = createSlice({
	name: "customizer",
	initialState,
	reducers: {
		setActiveMode: (state, action: PayloadAction<string>) => {
			state.activeMode = action.payload;
		},
		setActiveTheme: (state, action: PayloadAction<string>) => {
			state.activeTheme = action.payload;
		},
		setActiveLayout: (state, action: PayloadAction<string>) => {
			state.activeLayout = action.payload;
		},
		setIsCardShadow: (state, action: PayloadAction<boolean>) => {
			state.isCardShadow = action.payload;
		},
		setIsLayout: (state, action: PayloadAction<string>) => {
			state.isLayout = action.payload;
		},
		setIsCollapse: (state, action: PayloadAction<string>) => {
			state.isCollapse = action.payload;
		},
		setIsLanguage: (state, action: PayloadAction<string>) => {
			state.isLanguage = action.payload;
		},
		setIsSidebarHover: (state, action: PayloadAction<boolean>) => {
			state.isSidebarHover = action.payload;
		},
		setIsMobileSidebar: (state, action: PayloadAction<boolean>) => {
			state.isMobileSidebar = action.payload;
		},
		setIsLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		initializeCustomizer: (state) => {
			// Reset transient sidebar states (should not persist between sessions)
			state.isMobileSidebar = false;
			state.isSidebarHover = false;

			// Set document attributes
			if (typeof document !== "undefined") {
				document.documentElement.setAttribute("class", state.activeMode);
				document.documentElement.setAttribute(
					"data-color-theme",
					state.activeTheme,
				);
				document.documentElement.setAttribute(
					"data-layout",
					state.activeLayout,
				);
				document.documentElement.setAttribute(
					"data-boxed-layout",
					state.isLayout,
				);
				document.documentElement.setAttribute(
					"data-sidebar-type",
					state.isCollapse,
				);
			}
			// Mark as loaded
			state.isLoading = false;
		},
	},
});

export const {
	setActiveMode,
	setActiveTheme,
	setActiveLayout,
	setIsCardShadow,
	setIsLayout,
	setIsCollapse,
	setIsLanguage,
	setIsSidebarHover,
	setIsMobileSidebar,
	setIsLoading,
	initializeCustomizer,
} = customizerSlice.actions;

export default customizerSlice.reducer;
